import { Navigate, Outlet, useLocation } from "react-router-dom";
// import { ScreenPaths } from "../configs/paths";

export const PublicRoute = () => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  // If the user has a token, we usually redirect to home.
  // EXCEPT if we are on the landing/activation screen, because we want to show the success message post-activation.
  const isLandingPage = location.pathname.includes("terms-conditions");

  if (token && !isLandingPage) return <Navigate to="/" />;

  return <Outlet />;
};
